import { Flex, Text } from '@chakra-ui/react'
import { useUserState } from '~/atoms/UserState'
import { DateTimeRangeDropdown } from '~/components/shared/DateTimeRangeDropdown'
import { FilterButton } from '~/components/shared/FilterButton'
import { useGetCustomStatuses } from '~/queries/customStatusQueries'

const AVAILABILITY = {
  Online: 'online',
  Away: 'away',
} as const

const AgentStatusFilters = () => {
  const { pbxId } = useUserState()

  const { data: customStatuses } = useGetCustomStatuses(pbxId)
  const statusFilterData = [
    {
      title: 'Availability',
      rows: [
        {
          items: [
            { title: 'Online', data: AVAILABILITY.Online },
            { title: 'Away', data: AVAILABILITY.Away },
          ],
        },
      ],
    },
    {
      title: 'Status',
      rows: [
        {
          items:
            customStatuses?.map((status) => ({
              title: status.name,
              data: status.id,
            })) ?? [],
        },
      ],
    },
  ]
  return (
    <Flex
      width={'100%'}
      height={'4.5rem'}
      padding={'0rem 1.25rem'}
      justifyContent={'space-between'}
      alignItems={'center'}
      alignSelf={'stretch'}
      borderBottom={'2px solid var(--Gray-Gray400, #E5E5EE)'}
      background={'var(--Gray-Gray200, #F6F6FA);'}
    >
      <Text
        fontSize={'1.25rem'}
        fontWeight={'800'}
        lineHeight={'1.75rem'}
        color={'var(--Gray-Gray1300, #1D1D30);'}
      >
        Agent Status
      </Text>
      <Flex gap={'0.75rem'} display={'none'}>
        <DateTimeRangeDropdown
          onValueChange={() => {}}
          useQuickActionButton={false}
          dateTimeRange={undefined}
        />
        <FilterButton
          filterData={statusFilterData}
          title="Filter"
          activeFiltersCount={0}
          onFilterChangesApplied={() => {}}
          useQuickActionButton={false}
        />
      </Flex>
    </Flex>
  )
}

export default AgentStatusFilters
